var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sign-in-form-container" }, [
    _c("div", { staticClass: "sign-in-form-title" }, [
      _c(
        "button",
        {
          on: {
            click: function($event) {
              return _vm.redirectTo("/", "stretch")
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: require("@/common/assets/images/icon-left.webp"),
              alt: "back"
            }
          })
        ]
      ),
      _c("h2", [_vm._v("Sign in as a Guest")])
    ]),
    _c(
      "form",
      {
        staticClass: "sign-in-form",
        on: { submit: event => _vm.handleSubmit(event) }
      },
      [
        _c("div", { staticClass: "sign-in-form-content" }, [
          _c("label", { attrs: { for: "email" } }, [_vm._v("Email:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.username,
                expression: "formData.username"
              }
            ],
            ref: "email",
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("username") }
            ],
            attrs: {
              type: "email",
              id: "email",
              name: "email",
              placeholder: "Enter your email",
              autocomplete: "email",
              required: ""
            },
            domProps: { value: _vm.formData.username },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("username")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "username", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "sign-in-form-content" }, [
          _c("label", { attrs: { for: "password" } }, [_vm._v("Password:")]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.formData.password,
                expression: "formData.password"
              }
            ],
            ref: "password",
            class: [
              { "error-border": !_vm.FORM_VALIDATOR?.isFieldValid("password") }
            ],
            attrs: {
              type: "password",
              id: "password",
              name: "password",
              placeholder: "Enter your password",
              autocomplete: "password",
              required: ""
            },
            domProps: { value: _vm.formData.password },
            on: {
              focusout: function($event) {
                _vm.FORM_VALIDATOR?.validateFormField("password")
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.formData, "password", $event.target.value)
              }
            }
          }),
          _c(
            "span",
            {
              staticClass: "toggle-password",
              on: {
                click: function($event) {
                  return _vm.togglePasswordVisibility("password")
                }
              }
            },
            [_c("img", { attrs: { src: _vm.visible, alt: "eye" } })]
          )
        ]),
        _c(
          "span",
          {
            staticClass: "forgot-password",
            on: {
              click: function($event) {
                return _vm.redirectTo(`/forgot-password`)
              }
            }
          },
          [_vm._v(" Forgot my password? ")]
        ),
        _c(
          "div",
          { staticClass: "form-bottom" },
          [
            _vm._l(_vm.FORM_VALIDATOR?.errors(), function(error, index) {
              return _c("span", { key: index, staticClass: "error" }, [
                _vm._v(_vm._s(error.fieldCondition.message))
              ])
            }),
            _c("input", {
              class: [
                "sign-in-button",
                {
                  "not-allowed":
                    !_vm.FORM_VALIDATOR?.isFormValid() ||
                    (!_vm.formData.email && !_vm.formData.password)
                }
              ],
              attrs: { type: "submit", value: "SIGN IN" },
              on: {
                submit: function($event) {
                  return _vm.handleSubmit($event)
                }
              }
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }